import { createAsyncTypes } from 'utils/ActionCreator'

export const FETCH_DATA_ASYNC = createAsyncTypes('FETCH_DATA_ASYNC', 'Dashboard/Ade')

export const DATE_FILTER_CHANGE = 'Dashboard/Ade/DATE_FILTER_CHANGE'

export const ERROR_MESSAGE = 'The requested data cannot be displayed, please try again later.'
export const NO_DATA_MESSAGE =
  'There is no data to display within the selected time frame at this moment.'

export const LICENSE_DATA_REQUEST_ASYNC = createAsyncTypes(
  'LICENSE_DATA_REQUEST_REQUEST',
  'Dashboard/Ade'
)

export const TOGGLE_ADDON_TO_UNLOCK = 'Dashboard/Ade/TOGGLE_ADDON_TO_UNLOCK'
export const RESET_SELECTED_ADDONS = 'Dashboard/Ade/RESET_SELECTED_ADDONS'

export const TOTAL_WARNINGS_TEXT = 'Warning message'
export const EDITED_WARNINGS_TEXT = 'Modified'

export const adeInsightsTexts = {
  insight1: (
    <span>
      Consider training employees on proper email handling practices to ensure data security.
    </span>
  ),
}

export const noAdeFFTexts = {
  text1: (
    <span>
      <b>Minimize Risk</b> by reducing the likelihood of sensitive data breaches.
    </span>
  ),
}
